export const debounce = (func, wait = 250, immediate = false) => {
    // using David Waslsh's debounce
    // https://davidwalsh.name/javascript-debounce-function
    // which is take from underscore.js
    let timeout = null;

    return function () {
        const context = this;
        const args = arguments;
        const later = function () {
            timeout = null;
            if (!immediate) {
                func.apply(context, args);
            }
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) {
            func.apply(context, args);
        }
    };
};

export default debounce;
